import { useQuery } from '@apollo/client'
import { useUpdateEffect } from 'react-use'
import { GetBrandBySlugQuery, GetBrandBySlugQueryVariables } from 'types/graphql'
import { useCurrentUser } from 'modules/auth/useCurrentUser'
import { getBrandQuery } from './getBrand.graphql'

export const useBrand = (slug: string) => {
  const { data, loading, refetch } = useQuery<GetBrandBySlugQuery, GetBrandBySlugQueryVariables>(getBrandQuery, {
    variables: { slug },
    skip: !slug
  })
  const { isLoggedIn } = useCurrentUser()

  useUpdateEffect(() => {
    refetch({ slug })
  }, [isLoggedIn, refetch])

  return { data, loading, refetch }
}
